"use client";

// components
import Button from "@/shared/Button";

// assets
import styles from "@/assets/styles/pages/legal-page.module.scss";
import { useEffect } from "react";

export default function CookiesPageContent () {
  useEffect(() => {
    if (typeof window !== "undefined" && window.OneTrust) {
      // load OneTrust cookie policy data
      window.OneTrust.initializeCookiePolicyHtml();
    }
  }, []);
  
  return (
    <div className={styles["locl-legal-page"]} data-testid="cookies-page">
      <div id="ot-sdk-cookie-policy"></div>
      This Cookie Notice was last updated on 18th September 2023.
      <br/>
      <br/>
      <Button
        success
        type="secondary"
        onClick={() => window.OneTrust.ToggleInfoDisplay()}
      >
        Update cookie preferences
      </Button>
    </div>
  )
}
